var exports = {
  "kL": "x93eb46d8--ea9fb3--container",
  "R_": "x93eb46d8--ea9fb3--heading",
  "Wm": "x93eb46d8--ea9fb3--dropdown",
};

module.exports = exports;
